<template>
  <div class="page">

    <div class="bar_nav">
      <div class="title">群二维码</div>
      <div class="bar_back_btn" @click="goToGroupSetting">群组成员</div>
    </div>
    <div class="bar_empty"></div>

    <div class="qrcode_box">
      <div class="qrcode">
        <canvas id="qrcode"></canvas>
      </div>
      <div class="group_name">{{group.name}}</div>
      <div class="warning">二维码有效期10分钟，失效请重新打开</div>
    </div>

    <div class="tip">请用微信APP扫码，并加入群组</div>
    <!-- <div>{{inviteLink}}</div> -->
    <!-- <div class="warning">长按下载</div> -->
  </div>
</template>

<script>
import qrcode from 'qrcode'
export default {
  name: 'GroupQRCode',
  data: function () {
    return {
      inviteLink: '',
      group: {}
    }
  },
  async mounted() {
    try {
      const inviteCode = (await this.$faApi.generateInviteCode(this.$route.params.groupId)).inviteCode
      this.group = await this.$faApi.getGroupDetail(this.$route.params.groupId)
      const currentUser = await this.$faApi.getCurrentUser()
      this.inviteLink = `${location.protocol}//${location.host}/#/group/${this.$route.params.groupId}/join_group/${inviteCode}/${this.group.name}/${currentUser.fullName}`
      const qrcodeCanvas = document.getElementById('qrcode')
      qrcode.toCanvas(qrcodeCanvas, this.inviteLink, (err) => {
        if (err) this.$faLogger.error('GroupQRCode.vue:toCanvas', err)
      })
    } catch (err) {
      this.$faLogger.error('GroupQRCode.vue:mounted', err)
    }
  },
  methods: {
    goToGroupSetting() {
      this.$router.push({ path: `/group/${this.$route.params.groupId}/setting` })
    }
  }
}
</script>

<style scoped lang="scss">
  .page {
    width: 100%;
    height: 100%;
    background-color: #595969;
  }
  .qrcode_box {
    position: relative;
    margin: 48px auto;
    // padding: 48px;
    width: 240px;
    height: 320px;
    border-radius: 4px;
    background-color: white;
    .qrcode {
      position: relative;
      width: 240px;
      height: 240px;
      padding: 32px 0;
      // border: 1px solid red;
      text-align: center;
    }
    .group_name {
      position: relative;
      height: 48px;
      line-height: 24px;
      font-size: 20px;
      font-weight: bold;
      text-align: center;
    }
    .warning {
      position: absolute;
      bottom: 8px;
      left: 8px;
      right: 8px;
      height: 24px;
      line-height: 24px;
      font-size: 12px;
      font-weight: normal;
      text-align: center;
      color: white;
      background-color: red;
    } 
  }
  .tip {
    position: relative;
    margin: 0;
    padding: 0;
    font-size: 15px;
    font-weight: normal;
    text-align: center;
    color: lightgray;
  }
</style>
  